import { Component } from '@angular/core'
import {
  Appointment,
  AppointmentAvailability,
  AppointmentDate,
  AppointmentSlot
} from '../../../modules/appointment/appointment.types'
import { select, Store } from '@ngrx/store'
import { AAAStore } from '../../../store/root-reducer'
import {
  selectAppointment,
  toggleAppointmentDialog
} from '../../../modules/appointment/appointment.actions'
import {
  selectAppointmentAvailability,
  selectSelectedAppointment,
} from '../../../modules/appointment/appointment.selectors'
import { AbstractComponent } from '../../abstract.component'
import { selectAppointmentDialogState } from '../../../modules/ui/ui.selectors'
import { combineLatest, Observable, Subject } from 'rxjs'
import { switchMap } from 'rxjs/operators'

@Component({
  selector: 'drr-appointment-options-bottom-sheet',
  templateUrl: './appointment-options-bottom-sheet.component.html',
  styleUrls: ['./appointment-options-bottom-sheet.component.scss'],
})
export class AppointmentOptionsBottomSheetComponent extends AbstractComponent {

  appointmentDays: AppointmentDate[] = []
  selectedDate: AppointmentDate = null
  selectedSlot: AppointmentSlot = null
  private isOpenTrigger$ = new Subject<void>()

  constructor(
    private store$: Store<AAAStore>,
  ) {
    super()
  }

  appointmentDialogState$ = this.store$.pipe(select(selectAppointmentDialogState))

  appointmentData$: Observable<[Appointment, AppointmentAvailability]> = this.isOpenTrigger$.pipe(
    switchMap(() => combineLatest([
      this.store$.pipe(select(selectSelectedAppointment)),
      this.store$.pipe(select(selectAppointmentAvailability))
    ]))
  )

  ngOnInit() {
    this.subscriptions.push(
      this.appointmentData$.subscribe(([appointment, availability]) => {
        this.appointmentDays = availability.dates

        // Default to first date if available, with no slot selected.
        this.selectedDate = availability.dates?.[0] || null
        this.selectedSlot = null

        // If there is a pre-selected appointment, try to match it.
        if (appointment) {
          const foundDate = this.appointmentDays.find(
            (d) => d.date.getTime() === appointment.date.getTime()
          )
          if (foundDate) {
            this.selectedDate = foundDate
            this.selectedSlot = appointment.slot
          }
        }
      })
    )
  }

  onSelectedDay(appointmentDate: AppointmentDate) {
    this.selectedDate = appointmentDate
  }

  onSelectedSlot(appointmentSlot: AppointmentSlot) {
    this.selectedSlot = appointmentSlot
  }

  onConfirm() {
    this.store$.dispatch(selectAppointment({
      payload: this.selectedSlot ? {
        date: this.selectedDate.date,
        slot: this.selectedSlot
      } : null
    }))
    this.store$.dispatch(toggleAppointmentDialog({ payload: false }))
  }

  dismissModal() {
    this.store$.dispatch(toggleAppointmentDialog({ payload: false }))
  }

  onOpen() {
    this.isOpenTrigger$.next()
    console.log('TODO: sendPageLoadEvent - Send analytics here')
  }
}
